module.exports = __webpack_public_path__ + "static/media/cash-icon.daaaf63f.svg";